import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Collapse,
  ListItem,
  UnorderedList,
} from "@chakra-ui/react";
import { useMemo } from "react";
import { useApiError } from "../ApiError";

/**
 * @param {import("@chakra-ui/react").BoxProps & {
 * displayCaughtErrors?: boolean,
 * }} props
 */
function ApiErrorDetailRHF({ displayCaughtErrors = false, ...otherProps }) {
  const { message, uncaughtErrors, caughtErrors } = useApiError();

  const uncaughtErrorsList = useMemo(() => {
    return Object.values(uncaughtErrors);
  }, [uncaughtErrors]);

  const caughtErrorsList = useMemo(() => {
    return Object.values(caughtErrors);
  }, [caughtErrors]);

  return (
    <Collapse in={Boolean(message)} unmountOnExit={true}>
      <Box {...otherProps}>
        <Alert status="error" variant="top-accent">
          <AlertTitle display="block">{message}</AlertTitle>
        </Alert>

        {(uncaughtErrorsList?.length > 0 ||
          (displayCaughtErrors && caughtErrorsList?.length > 0)) && (
          <Alert status="error">
            <AlertDescription>
              <UnorderedList display="block" opacity={0.75}>
                {uncaughtErrorsList?.map?.((value, index) => (
                  <ListItem key={index}>{value}</ListItem>
                ))}

                {displayCaughtErrors && (
                  <>
                    {caughtErrorsList?.map?.((value, index) => (
                      <ListItem key={index}>{value}</ListItem>
                    ))}
                  </>
                )}
              </UnorderedList>
            </AlertDescription>
          </Alert>
        )}
      </Box>
    </Collapse>
  );
}

export default ApiErrorDetailRHF;
